module.exports = __webpack_public_path__ + "static/media/blog_grid_7.0d125e72.jpg";